import { render } from "./BaseTypeFormToolbar.vue?vue&type=template&id=0560953b"
import script from "./BaseTypeFormToolbar.vue?vue&type=script&lang=js"
export * from "./BaseTypeFormToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__